
import {defineComponent, PropType} from "vue";
import {Course} from "../../../../domain/entities/entities";

export default defineComponent({
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true
    }
  },

  setup() {
    /**
     * Formats course duration.
     * @param duration Number that tells how long the course can last (calculated from the sum of each content_provider duration [the content_provider duration is defined by the instructor]).
     * @returns Course duration in one of the following formats: 00:00:00h, 00:00m in case the hours are less than zero and 00h for too many hours.
     */
    function formattedDuration(duration: number) {
      const sec = duration;
      let hours: string | number = Math.floor(sec / 3600);
      let minutes: string | number = Math.floor((sec - hours * 3600) / 60);
      let seconds: string | number = sec - hours * 3600 - minutes * 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (hours > 24) {
        return hours + "h";
      }
      if (hours == 0) {
        return minutes + ":" + seconds + "m";
      }
      return hours + ":" + minutes + ":" + seconds + "h";
    }

    return {
      formattedDuration
    };
  }
});
